var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgOccupants = function SvgOccupants(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 79.945,
    height: 52.503
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#e4dcd3",
    strokeLinecap: "square",
    d: "M.5 51.819C.5 42.2 13.33 42.2 19.745 35.782c3.207-3.207-6.415-3.207-6.415-19.245Q13.33.5 26.159.5t12.83 16.037c0 16.037-9.622 16.037-6.415 19.245C38.989 42.2 51.819 42.2 51.819 51.819M45 42.58c2.248-.843 2.288-1.062 2.288-1.062 3.207-3.207-6.415-3.207-6.415-19.245 0-8.563 2.743-13.7 8.509-15.485a15.1 15.1 0 0 1 4.321-.553q12.831 0 12.83 16.037c0 16.037-9.622 16.037-6.415 19.245 6.415 6.415 14.9 3.045 19.147 10.3",
    "data-name": "Path 38"
  })));
};
export default SvgOccupants;